import { defineComponent as t, openBlock as n, createElementBlock as m, normalizeClass as r, createVNode as a, unref as s } from "vue";
import c from "../../../components/sequiter-image/sequiter-image.vue.js";
import { ICONS as l } from "../../../components/sequiter-image/icon-library.js";
import { newImageModel as i } from "../../../components/sequiter-image/image-model.js";
const g = /* @__PURE__ */ t({
  name: "close-toast-button",
  __name: "close-toast-button",
  setup(p) {
    const e = i(l.X, "close", "close");
    return (o, u) => (n(), m("button", {
      class: r(o.$options.name)
    }, [
      a(c, { "image-obj": s(e) }, null, 8, ["image-obj"])
    ], 2));
  }
});
export {
  g as default
};
//# sourceMappingURL=close-toast-button.vue2.js.map
